import { createNavigationContainerRef, DrawerActions } from '@react-navigation/native';
import { getDrawerStatusFromState } from '@react-navigation/drawer';
import React from 'react';
export { useDrawerStatus } from '@react-navigation/drawer';


class NavigationService {
    ref = createNavigationContainerRef();
    drawerOpenStatus = React.createRef("closed");
    isMobile = false;

    get drawerStatus () {
        return this.isMobile ? this.getDrawerOpenStatus()  : this.drawerOpenStatus.current;
    }

    set drawerStatus (drawerOpenStatus) {
        this.drawerOpenStatus.current = drawerOpenStatus;
    }

    state = null;

    setIsMobile(isMobile) {
        this.isMobile = isMobile;
    }

    // navigate(name, params) {
    //     if(!this._isNavigationReady()) return;
    //     this.ref.navigate(name, params);
    // }

    isDrawerForceClosed = false;
    setForceCloseDrawer(isDrawerForceClosed) {
        this.isDrawerForceClosed = !this.isMobile && isDrawerForceClosed;
        if (isDrawerForceClosed) {
            this.closeDrawer();
        }
    }

    getState() {
        return this.state;
    }

    setState(state) {
        this.state = state;
    }

    openDrawer() {
        if(!this._isNavigationReady()) return;
        if(this.isDrawerForceClosed) return;
        this.ref.dispatch(DrawerActions.openDrawer());
    }


    closeDrawer() {
        if(!this._isNavigationReady()) return;
        this.ref.dispatch(DrawerActions.closeDrawer());
    }

    getDrawerOpenStatus () {
        return getDrawerStatusFromState(this.getState())
    }

    isDrawerOpen () {
        if (!this.getState()) return false;
        return this.getDrawerOpenStatus() === 'open';
    }

    _isNavigationReady() {
        return this.ref.isReady();
    }
}


export const navigationService  = new NavigationService()